import _ from "lodash";
import { getIn } from "formik";
import React from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { RadioOld, Text, TextColors, TextTypes } from "@/component-library";
import { testLocator } from "@/lib/helpers/test-locator";

import { CONCLUSION_RATINGS } from "../CareManagementForm.schema";

import "./CareManagementFieldShared.styles.scss";
import "./CareManagementRatingFields.styles.scss";

const CareManagementRatingField = ({
  formikProps,
  isViewOnly,
  questionName,
  questionTitle,
  testId,
}) => {
  const value = _.get(formikProps.values, questionName);
  const errorMessage = getIn(formikProps.errors, questionName);
  const isTouched = getIn(formikProps.touched, questionName);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(questionName, event.target.value);
  };

  return (
    <tr>
      <td>
        <p className="CareManagementRatingFields--question_title">{questionTitle}</p>
        {errorMessage && isTouched && (
          <Text
            color={TextColors.red}
            layout="block"
            style={{ "text-align": "left" }}
            type={TextTypes.small}
          >
            {errorMessage}
          </Text>
        )}
      </td>
      {CONCLUSION_RATINGS.map((rating, index) => {
        return (
          <td key={rating || index}>
            <RadioOld
              checked={value === rating}
              className="CareManagementRatingFields--radio_button"
              disabled={isViewOnly}
              name={questionName}
              onChange={handleChange}
              radioClassName="CareManagementFieldShared--radio_button"
              value={rating}
              {...getAutomationDataAttr(testId)}
              {...testLocator(testId)}
            />
          </td>
        );
      })}
    </tr>
  );
};

export const CareManagementRatingFields = ({
  formikProps,
  isViewOnly,
  omitLine = false,
  questions,
  subTitle,
  testId,
  title,
}) => {
  const content = (
    <table className="CareManagementRatingFields--table" {...testLocator(testId)}>
      <tr>
        <td className="CareManagementRatingFields--grid_header">
          <h4 className="CareManagementFieldShared--title">{title}</h4>
          <p className="CareManagementRatingFields--subTitle">{subTitle}</p>
        </td>
        {CONCLUSION_RATINGS.map((rating, index) => {
          return (
            <td key={rating || index}>
              <p className="CareManagementRatingFields--rating_title">{rating}</p>
            </td>
          );
        })}
      </tr>
      {questions.map((question, index) => {
        let testIdSuffix = question.name.replaceAll("_", "-");
        const lastDotIndex = question.name.lastIndexOf(".");

        if (lastDotIndex !== -1) {
          testIdSuffix = testIdSuffix.substring(lastDotIndex + 1);
        }

        return (
          <CareManagementRatingField
            formikProps={formikProps}
            isViewOnly={isViewOnly}
            key={question.name || index}
            questionName={question.name}
            questionTitle={question.title}
            testId={`${testId}-${testIdSuffix}-field`}
          />
        );
      })}
    </table>
  );

  if (omitLine) {
    return content;
  }

  return (
    <div className="CareManagementRatingFields--wrapper">
      <div className="CareManagementRatingFields--line" />
      {content}
    </div>
  );
};
